
import React, {FC} from 'react';
import DynamicAsset from 'components/DynamicAsset';

import * as styles from './styles.module.scss';

type LeftImageProps = {
	imageSrc: string
	children: React.ReactNode
}

export const LeftImage: FC<LeftImageProps> = ({imageSrc, children}) => (
	<div className={styles.image}>
		<DynamicAsset
			className={styles.background}
			imageSrc={imageSrc}
			alt='AI assistant'
		/>
		<div className={styles.text}>
			{children}
		</div>
	</div>
);
